import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  public title!: string;
  public subTitle!: string;
  public message!: string;
  public footer!: string;

  constructor(
    public dialog: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      subTitle: string;
      message: string;
      footer: string;
      value: boolean;
    }
  ) { }

  ngOnInit() {
    this.title = this.data.title;
    this.subTitle = this.data.subTitle;
    this.message = this.data.message;
    this.footer = this.data.footer;
    this.data.value = true;
  }

  close() {
    this.dialog.close();
  }

}
